import React from 'react';
import { Brain, Cog, type LucideIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import ScrollReveal from '../ScrollReveal/ScrollReveal';
import './About.css';

const TEAM_ICONS: Record<string, LucideIcon> = {
  'Francesco Solari': Cog,
  'Fabio Palomino': Brain,
};

const About: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className="about editorial-section section-shell section-shell--primary section-after-curve" id="about">
      <div className="editorial-container">
        <ScrollReveal>
          <header className="about-header">
            <h2 className="section-heading">
              {t.about.titleLine1}{' '}
              <span className="section-heading-accent">{t.about.titleLine2}</span>
            </h2>
            <p className="section-intro">{t.about.intro}</p>
          </header>
        </ScrollReveal>

        <div className="about-list">
          {t.about.team.map((member, index) => {
            const Icon = TEAM_ICONS[member.name];

            return (
              <ScrollReveal key={member.name} delay={index * 100}>
                <article className="about-list-item editorial-list-item">
                  <div className="about-avatar" aria-hidden="true">
                    {Icon && <Icon size={28} strokeWidth={2} />}
                  </div>
                  <div className="about-list-content">
                    <h3 className="editorial-list-title">{member.name}</h3>
                    <p className="editorial-list-meta">{member.role}</p>
                    <p className="editorial-list-body">{member.description}</p>
                  </div>
                </article>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
